import { Component, Input } from '@angular/core';
import { ModalFooterProps, modalFooterStyles } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-modal-footer',
  templateUrl: './modal-footer.component.html',
})
export class ModalFooterComponent {
  @Input() css: ModalFooterProps['css'];

  public get modalFooter(): string[] {
    return [modalFooterStyles({ css: this.css }).className];
  }
}
